import headerAvatar   from './assets/header-avatar.png';
import headerCalendar from './assets/header-calendar.svg';

export const HEADER_IMAGES = {
  avatar:       headerAvatar,
  calendarIcon: headerCalendar,
};

// ── Couleurs du design system ─────────────────────────────────────────────────
export const COLORS = {
  textStrong: '#343535',
  textMedium: '#58595b',
  textWeak: '#939597',
  progressGreen: '#26ac30',
  progressGray: '#ECEEF3',
};

export const CATEGORIES_ORDER = [
  { id: 'contract' },
  { id: 'axa'},
  { id: 'offset'},
  { id: 'lead'},
  { id: 'protected'},
  { id: 'neat'},
  { id: 'nlbp'},
  { id: 'myselectra'},
];

// ── Palette du corps du trophée par niveau ──────────────────────────────────
export const LEVEL_BODY_COLORS = {
  empty: {
    outerA: '#EDE9EA', outerB: '#BEB5B6',
    innerA: '#C3BBBB', innerB: '#ECE8E9',
    strokeA: '#C9C2C3', strokeB: '#FFFFFF',
    radialA: '#DFD6D5', radialB: '#918888',
    bottomB: '#DECFCF',
    shadowR: 0.508, shadowG: 0.438, shadowB: 0.415,
  },
  beginner: {
    outerA: '#E0F0D8', outerB: '#A3C98F',
    innerA: '#B0D4A0', innerB: '#DFF0D6',
    strokeA: '#C8E6BC', strokeB: '#F0FBE8',
    radialA: '#D4ECCC', radialB: '#8CC47A',
    bottomB: '#C5E8B8',
    shadowR: 0.286, shadowG: 0.500, shadowB: 0.230,
  },
  bronze: {
    outerA: '#F1DCC1', outerB: '#BD8A65',
    innerA: '#BF8E69', innerB: '#E4C196',
    strokeA: '#EBD4B7', strokeB: '#FFE3CE',
    radialA: '#E3C29C', radialB: '#D1A479',
    bottomB: '#E4CBAD',
    shadowR: 0.283, shadowG: 0.159, shadowB: 0.057,
  },
  silver: {
    outerA: '#FAFAFA', outerB: '#C2C4CD',
    innerA: '#CDCFD6', innerB: '#EFEFF1',
    strokeA: '#DDDFE2', strokeB: '#FFFFFF',
    radialA: '#F5F7FF', radialB: '#B3B5C5',
    bottomB: '#D0DBFF',
    shadowR: 0.297, shadowG: 0.330, shadowB: 0.446,
  },
  gold: {
    outerA: '#FFF5DE', outerB: '#CFA365',
    innerA: '#D2A86C', innerB: '#F8E6C0',
    strokeA: '#FFF6E7', strokeB: '#FFF8EC',
    radialA: '#FFE4BA', radialB: '#DEA44D',
    bottomB: '#FFF1E3',
    shadowR: 0.458, shadowG: 0.257, shadowB: 0.071,
  },
  platinium: {
    outerA: '#F5F0E8', outerB: '#C8BCA8',
    innerA: '#D0C4B0', innerB: '#F0EBE2',
    strokeA: '#E8DFD0', strokeB: '#FFFAF0',
    radialA: '#EAE0D2', radialB: '#B8A890',
    bottomB: '#E5DAC8',
    shadowR: 0.440, shadowG: 0.380, shadowB: 0.300,
  },
  diamond: {
    outerA: '#D8ECF1', outerB: '#82B3BF',
    innerA: '#A1C9D3', innerB: '#D0ECF2',
    strokeA: '#D0ECF2', strokeB: '#E6F8FC',
    radialA: '#D0EBF2', radialB: '#8DD3E2',
    bottomB: '#B5EBFB',
    shadowR: 0.378, shadowG: 0.587, shadowB: 0.704,
  },
  elite: {
    outerA: '#E8D8F0', outerB: '#9B78B8',
    innerA: '#A888C0', innerB: '#DCC8EC',
    strokeA: '#D4BEE6', strokeB: '#F0E4FA',
    radialA: '#D0BAE4', radialB: '#9068B0',
    bottomB: '#C8AEE0',
    shadowR: 0.380, shadowG: 0.250, shadowB: 0.550,
  },
};